import React from 'react';
import { ValidationProps } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';

import { SavedReportForm } from 'app/area/shared/saved-reports/components/saved-report-form';
import { processSavedReport } from 'app/area/shared/saved-reports/utils/process-saved-report';
import { SavedReport, SavedReportValidation } from 'app/area/shared/saved-reports/types-store';
import { endpoints } from '../../common/endpoints';
import { DashboardAdminTranslation } from '../../constants';

interface SavedReportsModalProps {
  currentSavedReportId: number;
  currentSavedReport: SavedReport;
  currentSavedReportOnlyIdMode: boolean;
  allSavedReportIs: number[];

  updateCurrent: (savedReport: Partial<SavedReport>) => void;
  closeModal: () => void;

  loadEvaluation: (favouriteId: number, onUpdateSavedReport: (savedReport: SavedReport) => void) => void;

  updateSavedReport: (currentSavedReportId: number, savedReport: SavedReport, validation: SavedReportValidation) => void;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    }
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  updateValidation: (validation: SavedReportValidation) => void;
  displayError: (errorMessage: string) => void;

  locale: string;
  validation: { [T in keyof SavedReport]?: ValidationProps };
  translation: DashboardAdminTranslation;
}

export const SavedReportsModal: React.FC<SavedReportsModalProps> = ({
  currentSavedReportId, currentSavedReport, currentSavedReportOnlyIdMode, allSavedReportIs,
  updateCurrent, closeModal, loadEvaluation, updateSavedReport,
  options, loadOptions,
  updateValidation, displayError,
  locale, validation, translation
}) => {

  const onDone = processSavedReport({
    currentSavedReport, currentSavedReportId, allSavedReportIs,
    updateSavedReport, updateValidation, loadEvaluation, displayError, onClose: closeModal,
    validation, translation
  });

  const title = isDefinedIncludingZero(currentSavedReportId)
    ? translation.edit_connection
    : translation.add_report;

  return <ModalWrapper
    headerTitle={title}
    btnTitle={translation.done}
    btnCancelTitle={translation.cancel}
    onClose={closeModal}
    onDone={onDone}
    closeOnDone={false}
    isDisabled={!currentSavedReport?.code?.value}>
    <SavedReportForm
      savedReport={currentSavedReport}
      displayMySavedReport={!currentSavedReportOnlyIdMode}
      updateCurrent={updateCurrent}
      endpoints={endpoints}
      options={options}
      loadOptions={loadOptions}
      locale={locale}
      validation={validation}
      translation={translation} />
  </ModalWrapper>;
};
